import { AutogenLayoutDriverChoiceDetails } from "./autogen/AutogenLayoutDriverChoiceDetails";

export class DriverChoiceDetails extends AutogenLayoutDriverChoiceDetails {


}
